import React from "react";
import MultiSelectDropdown from "../../../../../components/multiSelectDropdown/multiSelectDropdown";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/introBreakdownSagas";

const PricingOptions = () => {
  const dispatch = useDispatch();

  const pricingOptions = useSelector((state) => state.introBreakdown.pricingOptions);
  const selectedPricingOptions = useSelector(
    (state) => state.introBreakdown.selectedPricingOptions
  );

  const onSelectChange = (data) => dispatch(actionCreators.updatePricingOptions(data));

  return (
    <MultiSelectDropdown
      options={pricingOptions}
      selectedFilters={selectedPricingOptions}
      placeholder="Select Sales Packages"
      labelKey="productName"
      enableOnly
      includeSelectAll
      numberDisplayed={0}
      onSelectChange={onSelectChange}
    />
  );
};

export default PricingOptions;
